'use strict';

/**
 * Updates the display of the wishlist count and triggers an optional animation.
 *
 * @function handleWishlistQty
 * @param {number} wishlistCount - The current count of items in the wishlist.
 * @param {boolean} [animateAgain=false] - A flag indicating whether to trigger the animation again.
 *
 */
function handleWishlistQty(wishlistCount, animateAgain) {
    var $wishlistEle = $('.wishlist-dot');
    if (wishlistCount > 0) {
        if (animateAgain) {
            $wishlistEle.addClass('wdot-active animation').one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function () {
                $(this).removeClass('animation');
            });
        } else {
            $wishlistEle.addClass('wdot-active');
        }
    } else {
        $wishlistEle.removeClass('wdot-active');
    }
}

/**
 * Retrieves the wishlist from session storage and returns it as an array
 * @returns {array} list of product IDs in the wishlist
 */
function getWishlistFromSession() {
    var wishlist = [];
    try {
        wishlist = sessionStorage.getItem('wishlist') ? JSON.parse(sessionStorage.getItem('wishlist')) : [];
    } catch (error) {
        wishlist = [];
    }
    return wishlist;
}
/**
 * storing the wishlist items into session storage
 * @param {json} wishlisData - data returned from the server's ajax call
 */
function setWishlistInStorage() {
    var wishlist = getWishlistFromSession();
    var wishlistProductTiles = $('.wishlist-tile').toArray();
    if (wishlistProductTiles && wishlistProductTiles.length > 0) {
        wishlistProductTiles.forEach(tile => {
            var pid = $(tile).data('pid');
            var itemInWishlist = [];
            var itemID;
            if (wishlist.length > 0) {
                itemInWishlist = wishlist.filter(item => item === pid);
            }
            if (itemInWishlist.length > 0) {
                itemID = itemInWishlist[0];
            }
            var wishlistIcon = $(tile);
            if (itemID && (itemID === pid)) {
                wishlistIcon.removeClass('add-to-wishlist').addClass('added-to-wishlist');
            } else {
                wishlistIcon.addClass('add-to-wishlist').removeClass('added-to-wishlist');
            }
        });
    }
}

/**
 * Fill wihslist icons if the product is in wishlist.
 */
function updateWishlistIcon() {
    var url = $('#getWishlistURL').val();
    if ($('.isLoggedInUser').val() !== 'true' || !url) {
        return;
    }
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (response) {
            var items = response && response.list && response.list.items ? response.list.items : [];
            var wishlistItemsID = [];
            var wishlistItemsIDStringified;
            if (items.length > 0) {
                items.forEach(item => {
                    wishlistItemsID.push(item.pid);
                });
            }
            try {
                wishlistItemsIDStringified = JSON.stringify(wishlistItemsID);
            } catch (error) {
                wishlistItemsIDStringified = '';
            }
            sessionStorage.setItem('wishlist', wishlistItemsIDStringified);
            setWishlistInStorage();
            handleWishlistQty(items.length, false);
        },
        error: function () {
        }
    });
}

/**
 * Handles displaying a toast message based on the response from the server.
 * @param {Object} data - The response object from the server.
 * @param {string} wishlistType - The type of wishlist action (e.g. 'addedtoWishList' or 'removedfromWishList').
 */
function handleToastOnWishlist(data, wishlistType) {
    let toastType = 'failureToast';
    if (wishlistType === 'addedtoWishList' && data.success) {
        toastType = 'successToast';
    }

    $('body').trigger(toastType, data.msg);
}

// this is for updation of wishlist icons on Ajax
$('body').on('init:wislist', function () {
    updateWishlistIcon();
});

$('body').on('click', '.add-to-wishlist', function (e) {
    e.preventDefault();
    var $this = $(this);
    var pid = $this.data('pid');
    if ($('.isLoggedInUser') && $('.isLoggedInUser').val() !== 'true') {
        window.isWishlistItem = true;
        window.wishlistPID = pid;
        $('#loginPopupModal').modal('show');
        // Reset wishlist flags when login modal is closed
        $(document).on('hidden.bs.modal', '#loginPopupModal', function () {
            window.isWishlistItem = false;
            window.wishlistPID = null;
        });
        return;
    }
    var url = $this.attr('addproducturl');
    var optionId = $this.closest('.product-detail').find('.product-option').attr('data-option-id');
    var optionVal = $this.closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
    optionId = optionId || null;
    optionVal = optionVal || null;
    if (!url || !pid) {
        return;
    }

    var wishlist = getWishlistFromSession();
    var itemInWishlist = wishlist.filter(item => item === pid);
    if (itemInWishlist.length === 0) {
        wishlist.push(pid);
    }

    var removeProductFromCart = $this.hasClass('remove-from-cart');

    $.spinner().start();
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: {
            pid: pid,
            optionId: optionId,
            optionVal: optionVal
        },
        success: function (data) {
            if (data && data.success) {
                var $wishlistDiv = $('.like .wishlist-tile[data-pid="' + pid + '"]');
                $wishlistDiv.removeClass('add-to-wishlist').addClass('added-to-wishlist');
                sessionStorage.setItem('wishlist', JSON.stringify(wishlist));
                handleWishlistQty(data.wishlistQty, true);
            }
            $('#removeProductModal').modal('hide');
            if (removeProductFromCart) {
                $('.cart-delete-confirmation-btn').data('triggeredByWishlist', true).trigger('click');
            }
            handleToastOnWishlist(data, 'addedtoWishList');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

$('body').on('click', '.added-to-wishlist', function (e) {
    e.preventDefault();
    var $this = $(this);
    var pid = $this.data('pid');
    var url = $this.attr('removeproducturl');
    var wishlistArray = getWishlistFromSession();
    var wishlist = wishlistArray.filter(item => item !== pid);

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        data: {
            pid: pid
        },
        success: function (data) {
            if (data && data.success) {
                var $wishlistDiv = $('.like .wishlist-tile[data-pid="' + pid + '"]');
                $wishlistDiv.addClass('add-to-wishlist').removeClass('added-to-wishlist');
                sessionStorage.setItem('wishlist', JSON.stringify(wishlist));
                handleWishlistQty(data.wishlistQty, false);
            }
            handleToastOnWishlist(data, 'removedFromWishList');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
});

updateWishlistIcon();

$('body').on('wishlist:updated', function (e, data) {
    handleWishlistQty(data);
});

$(document).ready(function () {
    handleWishlistQty(parseInt($('.wishlistQty').val(), 10));
});
